import React from 'react';
import './StatsBand.css';

const StatsBand = () => (
  <div className="stats-band reveal" id="stats">
    <div className="stats-glow"></div>
    <div className="stats-grid">
      <div><div className="stat-n">1M+</div><div className="stat-label">Downloads</div></div>
      <div><div className="stat-n">4.8★</div><div className="stat-label">Play Store Rating</div></div>
      <div><div className="stat-n">₹2B+</div><div className="stat-label">Target Monthly Volume</div></div>
      <div><div className="stat-n">99.9%</div><div className="stat-label">Uptime SLA</div></div>
    </div>
  </div>
);

export default StatsBand;
